/**
 * 每日一句 · 全站唯一来源
 * 登录开场动画、首页桌面 Hero、移动端 HeroSection 共用，保证同一天显示同一句诗，
 * 避免"开场动画与首页是两句不同的诗"。
 */
export interface DailyQuote {
  line: string;
  next: string;
  title: string;
  author: string;
  dynasty: string;
}

export const DAILY_QUOTES: DailyQuote[] = [
  { line: '不知细叶谁裁出，', next: '二月春风似剪刀。', title: '咏柳', author: '贺知章', dynasty: '唐' },
  { line: '春风又绿江南岸，', next: '明月何时照我还。', title: '泊船瓜洲', author: '王安石', dynasty: '宋' },
  { line: '举头望明月，', next: '低头思故乡。', title: '静夜思', author: '李白', dynasty: '唐' },
  { line: '野火烧不尽，', next: '春风吹又生。', title: '赋得古原草送别', author: '白居易', dynasty: '唐' },
  { line: '海内存知己，', next: '天涯若比邻。', title: '送杜少府之任蜀州', author: '王勃', dynasty: '唐' },
  { line: '会当凌绝顶，', next: '一览众山小。', title: '望岳', author: '杜甫', dynasty: '唐' },
  { line: '但愿人长久，', next: '千里共婵娟。', title: '水调歌头', author: '苏轼', dynasty: '宋' },
];

/** 当日索引（按日期轮换，全站一致）。 */
export function quoteIndexOfToday(): number {
  return new Date().getDate() % DAILY_QUOTES.length;
}

/** 当日这一句。 */
export function quoteOfToday(): DailyQuote {
  return DAILY_QUOTES[quoteIndexOfToday()];
}
